/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type bookmarksetBySpaceIdMutationVariables = {|
  userRef: string,
  spaceId: string,
|};
export type bookmarksetBySpaceIdMutationResponse = {|
  +result: ?{|
    +code: number,
    +success: boolean,
    +message: string,
  |}
|};
export type bookmarksetBySpaceIdMutation = {|
  variables: bookmarksetBySpaceIdMutationVariables,
  response: bookmarksetBySpaceIdMutationResponse,
|};
*/


/*
mutation bookmarksetBySpaceIdMutation(
  $userRef: String!
  $spaceId: String!
) {
  result: setSpaceBookmark(userRef: $userRef, spaceId: $spaceId) {
    code
    success
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userRef"
},
v2 = [
  {
    "alias": "result",
    "args": [
      {
        "kind": "Variable",
        "name": "spaceId",
        "variableName": "spaceId"
      },
      {
        "kind": "Variable",
        "name": "userRef",
        "variableName": "userRef"
      }
    ],
    "concreteType": "SpaceBookmarkPayload",
    "kind": "LinkedField",
    "name": "setSpaceBookmark",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "bookmarksetBySpaceIdMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "bookmarksetBySpaceIdMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1de651d0284dde9e1f487b4b223a8aa7",
    "id": null,
    "metadata": {},
    "name": "bookmarksetBySpaceIdMutation",
    "operationKind": "mutation",
    "text": "mutation bookmarksetBySpaceIdMutation(\n  $userRef: String!\n  $spaceId: String!\n) {\n  result: setSpaceBookmark(userRef: $userRef, spaceId: $spaceId) {\n    code\n    success\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '454125d4c3c18d0effe1b567876d7185';

module.exports = node;
